import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AdminPortalDashboard from './pages/admin-portal-dashboard';
import MyAccount from './pages/my-account';
import LoginPage from './pages/login';
import Home from './pages/home';
import EventManagerDashboard from './pages/event-manager-dashboard';
import EventDetail from './pages/event-detail';
import MyTicketsPage from './pages/my-tickets';
import OrderSuccessPage from './pages/order-success';
import CheckoutPage from './pages/checkout';
import Register from './pages/register';
import EventScanner from './pages/event-scanner';
import AdminUsersPage from './pages/admin/users';
import AdminEventsPage from './pages/admin/events';
import AdminFinancialPage from './pages/admin/financial';
import AdminSettingsPage from './pages/admin/settings';
import EventsPage from './pages/events';
import TicketsPage from './pages/tickets';
import SalesPage from './pages/sales';
import VenueManagementPage from './pages/venue-management';
import EventCreationManagementPage from './pages/event-creation-management';
import MerchandiseManagementPage from './pages/merchandise-management';
import ProtectedRoute from './components/ProtectedRoute';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Public routes */}
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<Register />} />
        <Route path="/event-detail" element={<EventDetail />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/order-success" element={<OrderSuccessPage />} />
        
        {/* Consumer routes */}
        <Route path="/my-account" element={<ProtectedRoute allowedRoles={['consumer', 'admin', 'manager']}><MyAccount /></ProtectedRoute>} />
        <Route path="/my-tickets" element={<ProtectedRoute allowedRoles={['consumer', 'admin', 'manager']}><MyTicketsPage /></ProtectedRoute>} />
        
        {/* Admin routes */}
        <Route path="/admin-portal-dashboard" element={<ProtectedRoute allowedRoles={['admin']}><AdminPortalDashboard /></ProtectedRoute>} />
        <Route path="/admin/users" element={<ProtectedRoute allowedRoles={['admin']}><AdminUsersPage /></ProtectedRoute>} />
        <Route path="/admin/events" element={<ProtectedRoute allowedRoles={['admin']}><AdminEventsPage /></ProtectedRoute>} />
        <Route path="/admin/financial" element={<ProtectedRoute allowedRoles={['admin']}><AdminFinancialPage /></ProtectedRoute>} />
        <Route path="/admin/settings" element={<ProtectedRoute allowedRoles={['admin']}><AdminSettingsPage /></ProtectedRoute>} />
        
        {/* Manager routes */}
        <Route path="/event-manager-dashboard" element={<ProtectedRoute allowedRoles={['manager', 'admin']}><EventManagerDashboard /></ProtectedRoute>} />
        <Route path="/venue-management" element={<ProtectedRoute allowedRoles={['manager', 'admin']}><VenueManagementPage /></ProtectedRoute>} />
        <Route path="/event-creation-management" element={<ProtectedRoute allowedRoles={['manager', 'admin']}><EventCreationManagementPage /></ProtectedRoute>} />
        <Route path="/merchandise-management" element={<ProtectedRoute allowedRoles={['manager', 'admin']}><MerchandiseManagementPage /></ProtectedRoute>} />
        <Route path="/event-scanner" element={<ProtectedRoute allowedRoles={['manager', 'admin']}><EventScanner /></ProtectedRoute>} />
        
        {/* Shared authenticated routes */}
        <Route path="/events" element={<EventsPage />} />
        <Route path="/tickets" element={<TicketsPage />} />
        <Route path="/sales" element={<ProtectedRoute allowedRoles={['manager', 'admin']}><SalesPage /></ProtectedRoute>} />
        
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;